import React from 'react'
import { Badge } from 'hljd'

export default store => [
  {
    title: '领取时间',
    dataIndex: 'time',
    render: (t, { created_at, is_viewed }) => {
      return (
        <Badge dot={is_viewed + '' !== '1'}>
          <span style={{ marginRight: 4 }}>{created_at}</span>
        </Badge>
      )
    }
  },
  {
    title: '用户名',
    dataIndex: ['user', 'nick']
  },
  {
    title: '操作',
    dataIndex: 'operator',
    render: (o, { id, user }) => {
      return user && user.id ? (
        <a onClick={store.contact(id, user || {})} style={{ color: '#448afc' }}>
          联系
        </a>
      ) : null
    }
  }
]
